const formatOptions = (options, t) => {
  return options.map(option => ({ ...option, label: t(option.label) }));
};

export default formatOptions;
